module.exports = __webpack_public_path__ + "0077cb50a626ce9d98c79390cb0b1824.svg";